var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeletedPhrase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.071,
    viewBox: "0 0 17 17.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22625",
    "data-name": "Group 22625",
    transform: "translate(-557 -212.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7522",
    "data-name": "Rectangle 7522",
    width: 17,
    height: 17,
    transform: "translate(557 213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "translate(561 226.929)",
    fill: "#505465",
    fontSize: 14,
    fontFamily: "Inter",
    fontWeight: 500,
    textDecoration: "line-through"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedPhrase);
export default __webpack_public_path__ + "static/media/Deleted-Phrase.19aa0f647d1628e7b096db96439b874c.svg";
export { ForwardRef as ReactComponent };